import React, {
  useEffect,
  useMemo,
  useReducer,
  useRef,
  useState,
  useContext,
  createContext,
  useCallback,
} from "react";
import ReactDOM from "react-dom";
import { useRouteMatch } from "react-router-dom";
import { Button, Text, Select, Pill, LinearProgress } from "../../components";
import rison from "rison";
import { TaskType } from "../../utils/constants";
import { useDevicePixelRatio } from "use-device-pixel-ratio";
import {
  IconButton,
  MenuItem,
  Toolbar,
  Tooltip,
  Tabs,
  Tab,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Helmet } from "react-helmet";
import _, { create, debounce } from "lodash";
import Editor from "@monaco-editor/react";
import {
  useLatestWorkflowDefs,
  useWorkflowDef,
  useWorkflowNamesAndVersions,
  useWorkflowVersions,
  useWorkflowVersionsDelayed,
} from "../../data/workflow";
import WorkflowDAG from "../../components/diagram/WorkflowDAG";
import WorkflowGraph from "../../components/diagram/WorkflowGraph";
import ResetConfirmationDialog from "./ResetConfirmationDialog";
import {
  configureMonaco,
  NEW_WORKFLOW_TEMPLATE,
  JSON_FILE_NAME,
} from "../../schema/workflow";
import SaveWorkflowDialog from "./SaveWorkflowDialog";
import update from "immutability-helper";
import { usePushHistory } from "../../components/NavLink";
import {
  deleteTaskFromList,
  getTaskObj,
  timestampRenderer,
  updateTaskList,
  splitTaskReferenceName,
  getDisplayName,
  saveTriggerApprovalTaskNodes,
  findJoinNode,
} from "../../utils/helpers";

import {
  KeyboardArrowLeftRounded,
  KeyboardArrowRightRounded,
} from "@material-ui/icons";
import WorkflowDefinationForm from "./WorkflowDefinationForm";
import TaskDefinationTab from "./TaskDefinationTab";
import { useQueryState } from "react-router-use-location-state";
import TaskPopperUi from "../../components/tasklistpopperui/TaskPopperUi";
import SwitchTaskPopperUI from "../../components/tasklistpopperui/SwitchTaskPopperUI";
import { generateRandomText } from "../../utils/helpers";
import ConfirmChoiceDialog from "../../components/ConfirmChoiceDialog";
import SwitchCasesPopperUI from "../../components/tasklistpopperui/SwitchCasesPopperUI";
import ForkPathsPopperUI from "../../components/tasklistpopperui/ForkPathsPopperUI";
import { loader } from "@monaco-editor/react";
import DefaultLoader from "../../components/DefaultLoader";
import { instanceOf } from "prop-types";
import { insert } from "formik";
import { getUserDetails } from "../../config";
// import { split } from "cypress/types/lodash";
import Split from "react-split";
import { WorkflowErrors } from "../../App";
import { red } from "@material-ui/core/colors";

const minCodePanelWidth = 500;
const useStyles = makeStyles({
  wrapper: {
    height: "100%",
    width: "100%",
  },
  workflowCodePanel: (workflowDefState) => ({}),
  workflowGraph: (workflowDefState) => ({}),
  resizer: (workflowDefState) => ({
    display: workflowDefState.toggleGraphPanel ? "block" : "none",
    width: 8,
    cursor: "col-resize",
    backgroundColor: "rgb(45, 45, 45, 0.05)",
    resize: "horizontal",
    "&:hover": {
      backgroundColor: "rgb(45, 45, 45, 0.3)",
    },
  }),
  workflowName: {
    fontWeight: "bold",
  },
  rightButtons: {
    display: "flex",
    flexGrow: 1,
    justifyContent: "flex-end",
    gap: 8,

    "&>button": {
      margin: "0.5rem 0",
      padding: "4px 0",
      fontSize: "0.75rem",
      fontFamily: "Poppins, regular",
      lineHeight: "1.5",
    },
  },

  verSelect: {
    "&>.MuiSelect-root": {
      paddingTop: 6,
      paddingBottom: 6,
      paddingRight: "24px !important",
    },
  },
  togglebtn: (workflowDefState) => ({
    display: !workflowDefState.toggleGraphPanel ? "flex" : "none",

    position: "relative",
    top: "-98%",
    left: "96%",
    backgroundColor: "var(--theme-primary)",
  }),
  editorLineDecorator: {
    backgroundColor: "rgb(45, 45, 45, 0.1)",
  },
  workflowDefTabs: {
    // marginBottom: "1rem",
  },
  workflowDefTabPannels: {
    height: "calc(100vh - 9rem)", //subtracted hieght for tab header and toolbar
    overflow: "auto",
  },
  taskPanel: {
    // background: "#fff",
    padding: 8,
  },
  saveCode: {
    display: "flex",
    marginLeft: ".7rem",
    width: "84%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  rightCodeBtn: {
    display: "flex",
    flexGrow: 1,
    justifyContent: "flex-end",
    gap: 8,

    "&>button": {
      margin: "0.5rem 0",
      padding: "4px 5px",
      fontSize: "0.75rem",
      fontFamily: "Poppins, regular",
      lineHeight: "1.5",
    },
  },
});

const actions = {
  NEW_SAVE_COMPLETE: 1,
  SAVE_COMPLETE: 2,
  CONFIRMATION_DIALOG_OPEN: 3,
  CONFIRMATION_DIALOG_CLOSE: 4,
  UPDATE_CODE_PANEL_WIDTH: 5,
  UPDATE_MODIFIED: 6,
  TOGGLE_GRAPH_PANEL: 7,
  SAVE_COMPLETE_CLOSE: 8,
  SAVE_CONFIRMATION_CLOSE: 9,
  SAVE_CONFIRMATION_OPEN: 10,
};

function workflowDefStateReducer(state, action) {
  switch (action.type) {
    case actions.TOGGLE_GRAPH_PANEL:
      return update(state, {
        toggleGraphPanel: {
          $set: !state.toggleGraphPanel,
        },
      });
    case actions.UPDATE_CODE_PANEL_WIDTH:
      return update(state, {
        workflowCodePanelWidth: {
          $set: `${action.newWidth}px`,
        },
      });
    default:
      return state;
  }
}

export default function Workflow(props) {
  const permissions = props?.permissions;
  const match = useRouteMatch();
  const navigate = usePushHistory();
  const [saveDialog, setSaveDialog] = useState(null);
  const [resetDialog, setResetDialog] = useState(false); // false=idle, undefined=current_version, otherwise version id
  const [isModified, setIsModified] = useState(null);
  const [dag, setDag] = useState(null);
  const [jsonErrors, setJsonErrors] = useState([]);
  const [jsonParseError, setJsonParseError] = useState(false);
  const [taskErrors, setTaskErrors] = React.useContext(WorkflowErrors);
  const [isEditorMounted, setIsEditorMounted] = useState(false);
  const [decorations, setDecorations] = useState([]);
  const [splitSizes, setSplitSizes] = useState([50, 50]);
  const [splitMinSizes, setSplitMinSizes] = useState([0, 500]);
  const [splitMaxSizes, setSplitMaxSizes] = useState([Infinity, 800]);
  const [isCodeModified, setIsCodeModified] = useState(false);
  const [resetWorkflowJson, setResetWorkflowJson] = useState(null);
  const [shouldResetWorkflow, setShouldResetWorklow] = useState(false);

  const dpr = useDevicePixelRatio({ defaultDpr: 1 });
  // ukwolk
  const [value, setValue] = useState(0);
  const workflowFormRef = useRef();
  let initialState = {
    inputParameters: [],
    outputParameters: {},
    restartable: false,
    timeoutPolicy: "",
    timeoutSeconds: 0,
    failureWorkflow: "",
  };
  const debouncedHandleChange = useRef(null);
  const [dataToBeAddedToJSON, setDataToBeAddedToJson] = useState(initialState);
  const [tasks, setTasks] = useState([]);
  const [clickedWorkflowNodeTaskRef, setClickedWorkflowNodeTaskRef] = useState(
    null
  );
  const [selectedTaskRison, setSelectedTaskRison] = useState("");
  const [clickedAddBtnNode, setClickedAddBtnNode] = useState("");
  const [clickedDeletePathBtnNode, setClickedDeletePathBtnNode] = useState("");
  const [clickedDeleteBtnNode, setClickedDeleteBtnNode] = useState({
    ref: null,
    openDialog: false,
    header: "",
    message: "",
  });
  const [showTasksPopper, setShowTasksPopper] = useState(false);
  const [taskSelectedFromList, setTaskSelectedFromList] = useState("");
  const [addTaskScrollTo, setAddTaskScrollTo] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [isTaskDataLoading, setIsTaskDataLoading] = useState(false);
  const [hasEditorLoaded, setHasEditorLoaded] = useState(false);
  const [taskData, setTaskData] = useState("");
  const [clickedTask, setClickedTask] = useState("");
  const [lastSavedVersion, setLastSavedVersion] = useState("");
  const [lastSavedCode, setLastSavedCode] = useState();
  const workflowName = _.get(match, "params.name");
  const [newWorkflow, setNewWorkflow] = useState(null);
  const [nodeClicked, setNodeClicked] = useState(null);
  const [hasChangedJQ, setHasChangedJQ] = useState(false);
  const [setEditorDelay, editorDelay] = useState(false);
  const [duration, setDuration] = useState(0);
  const [workflowDays, setWorkflowDays] = useState(0);
  const [workflowHours, setWorkflowHours] = useState(0);
  const [workflowMinutes, setWorkflowMinutes] = useState(0);
  const [workflowSeconds, setWorkflowSeconds] = useState(0);
  const {
    data: namesAndVersions,
    refetch: refetchNamesAndVersions,
  } = useWorkflowNamesAndVersions();

  const { data: wfVersions, refetch: refetchwfVersions } = useWorkflowVersions(
    workflowName
  );

  // const versions = useMemo(() => namesAndVersions.get(workflowName) || [], [
  //   namesAndVersions,
  //   workflowName,
  // ]);

  const versions = useMemo(() => wfVersions?.sort((a, b) => b - a) || []);

  useEffect(() => {
    refetchwfVersions();
  }, [workflowName]);

  function updateLoading(status) {
    setLoading(status);
  }

  function getVersion(selectedVersion = null) {
    if (versions && versions.length > 0) {
      let sortedversions = versions.sort((a, b) => b.version - a.version);

      if (
        selectedVersion &&
        selectedVersion > 0 &&
        selectedVersion < versions.length
      ) {
        return sortedversions[selectedVersion].version;
      } else {
        return sortedversions[0].version;
      }
    }
    return null;
  }
  var selectedVersion = _.get(match, "params.version");

  var validSelectedVersion = versions ? selectedVersion <= versions.length : 1;
  var latestVersion = getVersion();
  const workflowVersion =
    (_.isUndefined(selectedVersion) && workflowName) ||
    validSelectedVersion == false
      ? getVersion()
      : selectedVersion; // undefined for latest

  const [workflowDefState, dispatch] = useReducer(workflowDefStateReducer, {
    workflowCodePanelWidth: "50%",
    toggleGraphPanel: true,
  });
  const [selectedForkCase, setSelectedForkCase] = useState(null);
  const classes = useStyles(workflowDefState);

  const {
    data: workflowDef,
    isFetching,
    refetch: refetchWorkflow,
  } = useWorkflowDef(workflowName, workflowVersion, NEW_WORKFLOW_TEMPLATE);

  const { data: wfData, refetch } = useLatestWorkflowDefs();

  useEffect(() => {
    refetch();
  }, []);

  const handleResetWorkflowTab = () => {
    if (workflowFormRef.current) {
      workflowFormRef.current.resetForm();
    }
  };

  var prevWorkflowJson = useMemo(() => {
    var olderWorkflow = _.cloneDeep(workflowDef);
    if (olderWorkflow) {
      const version = olderWorkflow.version;
      var keepAttrForTasks = olderWorkflow.tasks.map(
        ({ category, startDelay, schemaName, ...keepAttrs }) => keepAttrs
      );

      var modifiedTasks = [];
      modifiedTasks = keepAttrForTasks.map((task) => {
        let sorted_obj = Object.keys(task)
          .sort()
          .reduce((temp_obj, key) => {
            temp_obj[key] = task[key];
            return temp_obj;
          }, {});
        return sorted_obj;
      });

      var detaisl = olderWorkflow;
      if (version === 1 && olderWorkflow.createTime) {
        detaisl = _.omit(olderWorkflow, "updateTime");
        detaisl.updateTime = olderWorkflow.createTime;
      }
      var dataAdded = _.omit(dataToBeAddedToJSON, "version");
      delete dataAdded.version;

      const json = {
        ...dataAdded,
        ...detaisl,
        tasks: modifiedTasks,
        timeoutPolicy:
          typeof dataToBeAddedToJSON?.timeoutPolicy === "string"
            ? dataToBeAddedToJSON.timeoutPolicy
                .toUpperCase()
                .split(" ")
                .join("_")
            : undefined,

        ttlSeconds: duration,
      };

      var modifiedJson = {};
      let allKeys = Object.keys(json);
      allKeys.sort();
      for (let i = 0; i < allKeys.length; i++) {
        modifiedJson[allKeys[i]] = json[allKeys[i]];
      }

      return JSON.stringify(modifiedJson, null, 2);
    }
  }, [
    workflowDef,
    dataToBeAddedToJSON,
    tasks,
    workflowDays,
    workflowHours,
    workflowMinutes,
    workflowSeconds,
  ]);

  const workflowJson = useMemo(() => {
    if (workflowDef && tasks) {
      var keepAttrForTasks = tasks
        ? tasks.map((task) => {
            if (task) {
              const {
                category,
                startDelay,
                schemaName,
                updateTime,
                ...keepAttrs
              } = task;
              return keepAttrs;
            }
            return {};
          })
        : [];

      var modifiedTasks = [];
      modifiedTasks = keepAttrForTasks.map((task) => {
        let sorted_obj = Object.keys(task)
          .sort()
          .reduce((temp_obj, key) => {
            temp_obj[key] = task[key];
            return temp_obj;
          }, {});
        return sorted_obj;
      });

      let updateTime;
      const version = prevWorkflowJson.version;

      if (version !== 1 && workflowDef.createTime && !updateTime) {
        updateTime = Date.now();
      } else if (version === 1 && workflowDef.createTime) {
        updateTime = workflowDef.createTime;
      }
      var dataAdded = _.omit(dataToBeAddedToJSON, "version");
      delete dataAdded.version;
      var json = {
        ...workflowDef,
        updateTime: updateTime,
        tasks: modifiedTasks,
        ...dataAdded,
        timeoutPolicy:
          typeof dataToBeAddedToJSON?.timeoutPolicy === "string"
            ? dataToBeAddedToJSON.timeoutPolicy
                .toUpperCase()
                .split(" ")
                .join("_")
            : undefined,

        ttlSeconds: duration,
      };
      var modifiedJson = {};
      let allKeys = Object.keys(json);
      allKeys.sort();
      for (let i = 0; i < allKeys.length; i++) {
        modifiedJson[allKeys[i]] = json[allKeys[i]];
      }
      setDag(new WorkflowDAG(null, json));
      return JSON.stringify(modifiedJson, null, 2);
    }
    // else if (!workflowDef){
    //     navigate('/workflowDefs?error=true')
    // }
  }, [
    workflowDef,
    dataToBeAddedToJSON,
    tasks,
    resetWorkflowJson,
    duration,
    workflowDays,
    workflowHours,
    workflowMinutes,
    workflowSeconds,
  ]);

  const workflowJsonWithoutSubWf = useMemo(() => {
    if (workflowDef && tasks) {
      // Filter out tasks with isSubWF === true
      const newTasks = tasks ? _.cloneDeep(tasks) : [];
      const filteredTasks = newTasks.filter(
        (task) =>
          task &&
          ((!task.isSubWF && task.name !== "LABEL_END_SUB_WORKFLOW") ||
            task.type === "SUB_WORKFLOW")
      );

      const keepAttrForTasks = filteredTasks.map((task) => {
        if (task) {
          const {
            category,
            startDelay,
            schemaName,
            updateTime,
            ...keepAttrs
          } = task;
          return keepAttrs;
        }
        return {};
      });

      const modifiedTasks = keepAttrForTasks.map((task) => {
        const sortedTask = Object.keys(task)
          .sort()
          .reduce((sortedObj, key) => {
            sortedObj[key] = task[key];
            return sortedObj;
          }, {});
        return sortedTask;
      });

      let updateTime;
      const version = prevWorkflowJson.version;

      if (version !== 1 && workflowDef.createTime && !updateTime) {
        updateTime = Date.now();
      } else if (version === 1 && workflowDef.createTime) {
        updateTime = workflowDef.createTime;
      }

      const dataAdded = _.omit(dataToBeAddedToJSON, "version");
      const json = {
        ...workflowDef,
        updateTime,
        tasks: modifiedTasks,
        ...dataAdded,
        timeoutPolicy:
          typeof dataToBeAddedToJSON?.timeoutPolicy === "string"
            ? dataToBeAddedToJSON.timeoutPolicy
                .toUpperCase()
                .split(" ")
                .join("_")
            : undefined,

        ttlSeconds: duration,
      };

      const sortedJson = Object.keys(json)
        .sort()
        .reduce((sortedObj, key) => {
          sortedObj[key] = json[key];
          return sortedObj;
        }, {});

      return JSON.stringify(sortedJson, null, 2);
    }
  }, [workflowDef, dataToBeAddedToJSON, tasks, resetWorkflowJson, duration]);

  useEffect(() => {
    if (workflowJson) {
      var workflowDef = JSON.parse(workflowJson);
    }
  }, [selectedVersion && workflowJson]);

  useEffect(() => {
    if (workflowJson) {
      var workflowDef = JSON.parse(workflowJson);
    }
  }, [workflowJson]);

  // useEffect(() => {
  //   console.log('editorDelay',editorDelay);
  // }, [editorDelay]);
  useEffect(() => {
    if (selectedVersion !== lastSavedVersion) {
      getVersion();
    }
  }, [lastSavedCode, lastSavedVersion]);

  const workflowDisplayName = useMemo(() => {
    if (workflowJson) {
      const parsedJson = JSON.parse(workflowJson);
      const { workflowName } = parsedJson;
      return workflowName;
    }
  }, [workflowJson]);

  const inputParameters = useMemo(() => {
    if (workflowJson) {
      const parsedJson = JSON.parse(workflowJson);
      const { inputParameters } = parsedJson;
      return inputParameters;
    }
  }, [workflowJson]);

  useEffect(() => {
    if (workflowDef) {
      setDag(new WorkflowDAG(null, workflowDef));
    }
  }, [workflowDef]);

  useEffect(() => {
    async function fetchData() {
      if (latestVersion) {
        if (lastSavedVersion && lastSavedVersion > latestVersion) {
          navigate(`/workflowDef/${workflowName}/${lastSavedVersion}`);
        } else if (selectedVersion && selectedVersion == latestVersion) {
          navigate(`/workflowDef/${workflowName}`);
        } else if (selectedVersion && selectedVersion > latestVersion) {
          navigate(`/workflowDef/${workflowName}/${latestVersion}`);
        }
      }
    }
    fetchData();
  }, [getVersion, selectedVersion]);

  // Refs
  const editorRef = useRef();
  const resizeRef = useRef();

  // Resize Handle
  const handleMouseDown = () => {
    document.addEventListener("mouseup", handleMouseUp, true);
    document.addEventListener("mousemove", handleMouseMove, true);
  };

  const handleMouseUp = () => {
    document.removeEventListener("mouseup", handleMouseUp, true);
    document.removeEventListener("mousemove", handleMouseMove, true);
  };

  const handleMouseMove = (e) => {
    let boundingClientRect = ReactDOM.findDOMNode(
      resizeRef.current
    ).getBoundingClientRect();
    const newWidth = Math.max(
      minCodePanelWidth,
      e.clientX - boundingClientRect.x
    );
    dispatch({ type: actions.UPDATE_CODE_PANEL_WIDTH, newWidth: newWidth });
  };

  // Version Change or Reset
  const handleResetVersion = (version) => {
    if (isModified) {
      setResetDialog(version);
    } else {
      changeVersionOrReset(version);
    }
  };

  const changeVersionOrReset = (version) => {
    if (_.isUndefined(workflowName) && version == null) {
      setTasks([..._.cloneDeep(workflowDef.tasks)]);
      setShouldResetWorklow(true);
      handleResetWorkflowTab();
      const clickedTaskObj = workflowDef.tasks.find(
        (task) => task.type !== "LABEL"
      );
      setClickedTask(clickedTaskObj);
      setTaskData(clickedTaskObj);

      setResetDialog(false);
      setIsModified(false);
      setTaskErrors([]);
      setSelectedTaskRison("");
    } else {
      setResetDialog(false);
      setIsModified(false);
      setTaskErrors([]);
      setSelectedTaskRison("");
      if (version === workflowVersion) {
        // Reset to fetched version
        var oldJson = JSON.stringify(workflowDef, null, 2);
        if (editorRef?.current?.getModel()) {
          // editorRef.current.getModel().setValue(oldJson);
          for (let ele in dataToBeAddedToJSON) {
            setDataToBeAddedToJson((prevState) => ({
              ...prevState,
              [ele]: workflowDef[ele],
            }));
          }

          setTasks([..._.cloneDeep(workflowDef.tasks)]);
          const clickedTaskObj = workflowDef.tasks.find(
            (task) => task.type !== "LABEL"
          );
          setClickedTask(clickedTaskObj);

          setTaskData(clickedTaskObj);
          // setValue(0);
          if (_.isUndefined(version)) {
            navigate(`/workflowDef/${workflowName}`);
          } else {
            navigate(`/workflowDef/${workflowName}/${version}`);
          }
        }
      } else if (_.isUndefined(version)) {
        navigate(`/workflowDef/${workflowName}`);
      } else if (version) {
        navigate(`/workflowDef/${workflowName}/${version}`);
      } else {
        navigate(`/workflowDef/${workflowName}`);
      }
    }
  };

  const handleOpenSave = () => {
    const modified = editorRef.current.getValue();

    var jsonObject = JSON.parse(modified);

    // jsonObject.tasks.forEach((task) => {
    //   // Check if the task has input parameters
    //   if (task.inputParameters && task.inputParameters.statusId !== undefined) {
    //     // If the task has a parameter named "statusId", update its value to "hello"
    //     var id = window.localStorage.getItem("statusId");
    //     task.inputParameters.statusId = id;
    //   }
    //   if (
    //     task.inputParameters &&
    //     task.inputParameters.subStatusId !== undefined
    //   ) {
    //     // If the task has a parameter named "statusId", update its value to "hello"
    //     var id = window.localStorage.getItem("subStatusId");
    //     task.inputParameters.subStatusId = id;
    //   }
    // });

    let updateTime;
    const version = prevWorkflowJson.version;
    if (version !== 1 && workflowDef.createTime) {
      updateTime = Date.now();
    } else if (version === 1 && workflowDef.createTime) {
      updateTime = workflowDef.createTime;
    }
    jsonObject.updateTime = updateTime;
    function transformTasks(tasks) {
      // Filter out tasks with issubwf === true or "LABEL_END_SUB_WORKFLOW" unless type is "SUB_WORKFLOW"
      const filteredTasks = tasks.filter(
        (task) =>
          (!task.isSubWF && task.name !== "LABEL_END_SUB_WORKFLOW") ||
          task.type === "SUB_WORKFLOW"
      );

      // Remove unwanted attributes and keep necessary ones
      const keepAttrForTasks = filteredTasks.map(
        ({ category, startDelay, schemaName, updateTime, ...keepAttrs }) =>
          keepAttrs
      );

      // Sort remaining attributes of each task
      const modifiedTasks = keepAttrForTasks.map((task) => {
        const sortedTask = Object.keys(task)
          .sort()
          .reduce((sortedObj, key) => {
            sortedObj[key] = task[key];
            return sortedObj;
          }, {});
        return sortedTask;
      });

      return modifiedTasks;
    }

    // Apply the transformation to the tasks array
    jsonObject.tasks = transformTasks(jsonObject.tasks);

    // If there are decision cases or default cases within any task, apply the transformation to those as well
    jsonObject.tasks = jsonObject.tasks.map((task) => {
      if (task.decisionCases) {
        for (let key in task.decisionCases) {
          task.decisionCases[key] = transformTasks(task.decisionCases[key]);
        }
      }
      if (task.defaultCase) {
        task.defaultCase = transformTasks(task.defaultCase);
      }
      return task;
    });

    // Sorting the attributes of the final JSON object
    const sortedWorkflowObj = Object.keys(jsonObject)
      .sort()
      .reduce((sortedObj, key) => {
        sortedObj[key] = jsonObject[key];
        return sortedObj;
      }, {});

    // Convert the sorted JSON object to a string with pretty formatting
    const finalJson = JSON.stringify(sortedWorkflowObj, null, 2);
    // var modifiedJsonData = JSON.stringify(jsonObject);

    setSaveDialog({
      // original: workflowName ? workflowJson : "",
      original: workflowName ? prevWorkflowJson : "",
      originalObj: workflowName ? workflowDef : null,
      modified: finalJson,
    });
    setLastSavedCode(finalJson);
  };
  const handleSaveCancel = () => {
    setSaveDialog(null);
  };

  const handleSaveSuccess = (name, version) => {
    setSaveDialog(null);
    setLastSavedVersion(version);
    setIsCodeModified(false);
    setIsModified(false);
    refetchNamesAndVersions();
    refetchwfVersions();
    const clickedTaskObj = workflowDef.tasks[0];
    // setClickedTask(clickedTaskObj);
    // setTaskData(clickedTaskObj);
    navigate(`/workflowDef/${name}/${version}`);
  };

  // Monaco Handlers
  const handleEditorWillMount = (monaco) => {
    configureMonaco(monaco);
  };

  const handleEditorDidMount = (editor) => {
    editorRef.current = editor;
    setHasEditorLoaded(editor ? true : false);
  };

  const handleValidate = (markers) => {
    setJsonErrors(markers);
    setIsEditorMounted(true);
  };

  const handleJsonErrors = (errors) => {
    setJsonErrors(errors);
  };

  const handleEditorChange = useCallback((value, event) => {
    if (value === "") {
      handleChange(value);
      return;
    }

    if (debouncedHandleChange.current) {
      debouncedHandleChange.current.cancel();
    }

    debouncedHandleChange.current = debounce((value) => {
      handleChange(value);
    }, 4000);

    debouncedHandleChange.current(value);
  }, []);

  const handleChange = (v) => {
    setIsModified(v !== workflowJson);
    setIsCodeModified(v !== workflowJson);

    try {
      var parsedNewWorkflow = JSON.parse(v);
      if (parsedNewWorkflow) {
        setNewWorkflow(v);
        setTasks([..._.cloneDeep(parsedNewWorkflow.tasks)]);
        setJsonParseError(false);
      }
    } catch (e) {
      setJsonParseError(true);
      return console.error(e);
    }
  };

  const selectedTask = useMemo(
    () => selectedTaskRison && rison.decode(selectedTaskRison),
    [selectedTaskRison]
  );
  const handleExpandChange = () => {
    const addIsSubWF = (task) => {
      const modifiedTask = { ...task, isSubWF: true };

      if (modifiedTask.decisionCases) {
        Object.keys(modifiedTask.decisionCases).forEach((key) => {
          modifiedTask.decisionCases[key] = modifiedTask.decisionCases[key].map(
            addIsSubWF
          );
        });
      }

      ["defaultCase", "loopOver", "forkTasks"].forEach((key) => {
        if (modifiedTask[key]) {
          modifiedTask[key] = modifiedTask[key].map(addIsSubWF);
        }
      });

      return modifiedTask;
    };

    var currentTask = tasks.find(
      (e) => e.taskReferenceName === selectedTask?.ref
    );
    var currentTaskSubWFName = currentTask.subWorkflowParam.name;

    const wf = wfData.find((e) => e.name === currentTaskSubWFName);
    if (wf) {
      const wfTasks = wf.tasks;
      const index = tasks.findIndex(
        (e) => e.taskReferenceName === selectedTask?.ref
      );
      const randomText = generateRandomText();

      const startWFTask = {
        asyncComplete: false,
        displayName: "START SUB WORKFLOW",
        hideTask: false,
        inputParameters: {},
        name: "LABEL_START_SUB_WORKFLOW",
        optional: false,
        taskReferenceName: `LABEL_START_SUB_WORKFLOW_${randomText}_ref`,
        type: "LABEL",
        isSubWF: true,
      };

      const endWFTask = {
        asyncComplete: false,
        displayName: "END SUB WORKFLOW",
        hideTask: false,
        inputParameters: {},
        name: "LABEL_END_SUB_WORKFLOW",
        optional: false,
        taskReferenceName: `LABEL_END_SUB_WORKFLOW_${randomText}_ref`,
        type: "LABEL",
      };

      if (index !== -1) {
        const previousTask = { ...tasks[index], isSubWF: true };
        const newTasks = [
          ...tasks.slice(0, index),
          previousTask,
          startWFTask,
          ...wfTasks.map(addIsSubWF),
          endWFTask,
          ...tasks.slice(index + 1),
        ];
        setTasks(newTasks);
      }
    }
    // }
    //  else {
    //   const { task } = expandedSubWf;

    // let originalTasks = tasks.filter(task => (!task.isSubWF || task.type === 'SUB_WORKFLOW'))
    //                          .filter(task => !(task.name === 'LABEL_END_SUB_WORKFLOW'));

    // const index = originalTasks.findIndex(e => e.taskReferenceName === vals.taskReferenceName);

    // if (index !== -1) {
    //   originalTasks[index] = { ...originalTasks[index] };
    //   delete originalTasks[index].isSubWF;
    // }

    // setTasks(originalTasks);

    //   setExpandedSubWf({
    //     task: null,
    //     index: null,
    //     length: null
    //   });
    // }

    // setIsExpanded(exp);
  };

  const handleCollapseChange = () => {
    let originalTasks = tasks
      .filter((task) => !task.isSubWF || task.type === "SUB_WORKFLOW")
      .filter((task) => !(task.name === "LABEL_END_SUB_WORKFLOW"));

    const index = originalTasks.findIndex(
      (e) => e.taskReferenceName === selectedTask?.ref
    );

    if (index !== -1) {
      originalTasks[index] = { ...originalTasks[index] };
      delete originalTasks[index].isSubWF;
    }

    setTasks(originalTasks);
  };
  const handleWorkflowNodeClick = (node) => {
    setLoading(true);
    if (node.ref) {
      if (
        splitTaskReferenceName(selectedTask?.ref) ===
        splitTaskReferenceName(node.ref)
      ) {
        setLoading(false);
        if (value !== 1) setValue(1);
        return;
      }
      let taskObj = getTaskObj(tasks, node.ref);
      setNodeClicked(taskObj);
      if (
        taskObj &&
        (taskObj.name === TaskType.EndOfSwitch ||
          taskObj.name === TaskType.SwitchCase ||
          taskObj.name === TaskType.Default ||
          taskObj.name === TaskType.ForkBranch ||
          taskObj.name === TaskType.EndOfForkJoin ||
          taskObj.name === TaskType.EndOfDoWhile ||
          taskObj.name === TaskType.Label ||
          (taskObj.isSubWF === true && taskObj.name !== TaskType.SubWorkflow))
      ) {
        setLoading(false);
        return;
      }
    }

    let editor = editorRef?.current?.getModel() || null;
    if (!editor) return;
    let searchResult = editor.findMatches(`"taskReferenceName": "${node.ref}"`);
    if (searchResult.length) {
      editorRef.current.revealLineInCenter(
        searchResult[0]?.range?.startLineNumber,
        0
      );
      setDecorations(
        editorRef.current.deltaDecorations(decorations, [
          {
            range: searchResult[0]?.range,
            options: {
              isWholeLine: true,
              inlineClassName: classes.editorLineDecorator,
            },
          },
        ])
      );
      setClickedWorkflowNodeTaskRef(node.ref);
      setSelectedTaskRison(rison.encode(node));
      setValue(1);
      setTimeout(() => {
        setLoading(false);
      }, 800);
    } else {
      setLoading(false);
    }
  };

  const handleWorkflowAddBtnClick = (nodeRefObj) => {
    setClickedAddBtnNode(nodeRefObj.ref);
    setShowTasksPopper(true);
  };

  const handleSwitchCaseDeleteBtnClick = (nodeRefObj) => {
    setClickedDeletePathBtnNode(nodeRefObj.ref);
    setShowTasksPopper(true);
  };

  const handleWorkflowDeleteBtnClick = (nodeRefObj) => {
    setClickedDeleteBtnNode({
      ref: nodeRefObj.ref,
      openDialog: true,
      header: "Confirmation",
      message: "Are you sure you want to delete this task?",
    });
  };

  const handleConfirmDelete = (val) => {
    const { ref, confirm } = val;
    if (confirm) {
      const str = ref;
      const match = splitTaskReferenceName(ref);
      let endSwitchTaskRerenceName = "";
      let endDoWhileTaskReferenceName = "";
      let joinTaskReferenceName = "";
      if (
        str.startsWith(TaskType.Switch) &&
        !str.startsWith(TaskType.SwitchCase) &&
        !str.startsWith(TaskType.SwitchCase)
      ) {
        endSwitchTaskRerenceName = `${TaskType.EndOfSwitch}_${match}_ref`;
      } else if (str.startsWith(TaskType.DoWhile)) {
        endDoWhileTaskReferenceName = `${TaskType.EndOfDoWhile}_${match}_ref`;
      } else if (str.startsWith(TaskType.ForkJoin)) {
        const { task, tasks: allTasks, taskIndex } = findNode(tasks, ref);
        let joinNode = allTasks[taskIndex + 1];
        joinTaskReferenceName = joinNode ? joinNode.taskReferenceName : "";
      }

      const taskListAfterDelete = deleteTaskFromList(tasks, ref);

      setTasks(taskListAfterDelete);

      if (endSwitchTaskRerenceName) {
        var deletedTasks = taskListAfterDelete.filter(
          (item) => item.taskReferenceName !== endSwitchTaskRerenceName
        );
        setTasks(deletedTasks);
      }

      if (endDoWhileTaskReferenceName) {
        var deletedTasks = taskListAfterDelete.filter(
          (item) => item.taskReferenceName !== endDoWhileTaskReferenceName
        );
        setTasks(deletedTasks);
      }

      if (joinTaskReferenceName) {
        var deletedTasks = taskListAfterDelete.filter(
          (item) => item.taskReferenceName !== joinTaskReferenceName
        );
        setTasks(deletedTasks);
      }

      setClickedDeleteBtnNode({
        ref: null,
        openDialog: false,
        header: "",
        message: "",
      });
      setValue(0);
      setTimeout(() => {
        let errorArr = [...taskErrors];
        errorArr = errorArr.filter((e) => e.fieldId.split("_")[1] !== match);
        setTaskErrors(errorArr);
      }, 100);
    } else {
      setClickedDeleteBtnNode({
        ref: null,
        openDialog: false,
        header: "",
        message: "",
      });
      setValue(0);
    }
  };

  const reIndexForkPaths = (data) => {
    let dataToBeModified = data;
    if (dataToBeModified && dataToBeModified.forkTasks) {
      for (let i = 0; i < dataToBeModified.forkTasks.length; i++) {
        let forkBranch = dataToBeModified.forkTasks[i];
        if (forkBranch && forkBranch.length > 1) {
          let forkNode = forkBranch[0];
          forkNode.displayName = "Fork Path " + `${i + 1}`;
        }
      }
    }
    setTasks(_.cloneDeep(tasks));
  };

  const handleDeleteForkPath = (parentTask, selectedForkCase) => {
    const updatedForkTasks = deleteForkPathFromTask(
      parentTask,
      selectedForkCase
    );
    setTasks(_.cloneDeep(tasks)); // Update state with new fork tasks
    setTimeout(() => {
      handleWorkflowNodeClick({ ref: parentTask.taskReferenceName });
    }, 500);
  };

  const deleteForkPathFromTask = (
    parentTask,
    selectedForkCase,
    onDeleteCallback
  ) => {
    let { task, allTasks, taskIndex } = findNode(
      tasks,
      parentTask.taskReferenceName
    );
    if (task && task.type === TaskType.ForkJoin) {
      if (!task.forkTasks || _.isEmpty(task.forkTasks)) {
        task.forkPaths = [[]];
      }

      task.forkTasks.splice(selectedForkCase, 1);
      let joinNode = findJoinNode(tasks, task.taskReferenceName);
      joinNode.forkTasks = task.forkTasks;
      let lastTaskRefs = task.forkTasks.map((r) => _.last(r).taskReferenceName);
      if (joinNode.joinOn) {
        var filtered = joinNode.joinOn.filter(function (element) {
          return lastTaskRefs.indexOf(element) === -1;
        });

        let excludedArr = joinNode.joinOn.filter(
          (el) => !filtered.includes(el)
        );
        joinNode.joinOn = excludedArr;
      }
    }

    setTasks(_.cloneDeep(tasks));
    reIndexForkPaths(parentTask);
    closeTasksPopper();

    // Trigger the callback to inform that a fork path was deleted
    if (onDeleteCallback) {
      onDeleteCallback();
    }
  };

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
    if (workflowJson) {
      if (newValue !== 2 && editorRef?.current?.getModel()) {
        editorRef.current.getModel().setValue(workflowJson);
        if (debouncedHandleChange.current)
          debouncedHandleChange.current.cancel();
      }

      var modifiedWorkflowJson;
      var detaisl;

      if (workflowJson) {
        modifiedWorkflowJson = _.omit(JSON.parse(workflowJson), "updateTime");
      }

      if (prevWorkflowJson) {
        detaisl = _.omit(JSON.parse(prevWorkflowJson), "updateTime");
      }

      setIsModified(!_.isEqual(detaisl, modifiedWorkflowJson));
    }
  };

  const handleTaskSelectedFromList = (selectedTask) => {
    setTaskSelectedFromList(selectedTask);
  };

  useEffect(() => {
    if (workflowDef) {
      for (let ele in dataToBeAddedToJSON) {
        setDataToBeAddedToJson((prevState) => ({
          ...prevState,
          [ele]: workflowDef[ele],
        }));
      }
      setTasks([...workflowDef.tasks]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workflowDef]);

  useEffect(() => {
    var modifiedWorkflowJson;
    var detaisl;

    if (workflowJson) {
      modifiedWorkflowJson = _.omit(JSON.parse(workflowJson), "updateTime");
    }

    if (prevWorkflowJson) {
      detaisl = _.omit(JSON.parse(prevWorkflowJson), "updateTime");
    }

    if (hasEditorLoaded) {
      setIsModified(!_.isEqual(detaisl, modifiedWorkflowJson));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataToBeAddedToJSON]);

  useEffect(() => {
    if (
      tasks &&
      tasks.length === 1 &&
      hasEditorLoaded &&
      splitTaskReferenceName(selectedTask?.ref) !==
        splitTaskReferenceName(tasks[0].taskReferenceName)
    ) {
      handleWorkflowNodeClick({ ref: tasks[0].taskReferenceName || "" });
    } else if (
      tasks &&
      tasks.length &&
      workflowName &&
      workflowVersion &&
      hasEditorLoaded &&
      !selectedTask
    ) {
      const clickedTaskObj = tasks.find((task) => task.type !== "LABEL");
      handleWorkflowNodeClick({ ref: clickedTaskObj.taskReferenceName || "" });
    }

    if (hasEditorLoaded) {
      var modifiedWorkflowJson;
      var detaisl;

      if (workflowJson) {
        modifiedWorkflowJson = _.omit(JSON.parse(workflowJson), "updateTime");
        modifiedWorkflowJson = _.omit(
          modifiedWorkflowJson,
          "tasks[0].mapTicketIdToWorkflow"
        );
        modifiedWorkflowJson = _.omit(
          modifiedWorkflowJson,
          "tasks[0].requestId"
        );

        modifiedWorkflowJson.name = _.isNull(modifiedWorkflowJson.name)
          ? ""
          : modifiedWorkflowJson.name;
      }

      if (prevWorkflowJson) {
        detaisl = _.omit(JSON.parse(prevWorkflowJson), "updateTime");
      }
      const removeEmptyHeaders = (json) => {
        if (json?.tasks?.length) {
          for (let task of json.tasks) {
            const inputParameters = task?.inputParameters;
            const hasHeaders = inputParameters
              ? "headers" in inputParameters
              : false;
            const headers = hasHeaders ? inputParameters.headers : null;
            const isEmptyHeader = headers
              ? Object.keys(headers).length === 1 && headers[""] === ""
              : false;

            if (isEmptyHeader) {
              delete task.inputParameters.headers;
            }
          }
        }
        return json;
      };
      modifiedWorkflowJson = removeEmptyHeaders(modifiedWorkflowJson);
      detaisl = removeEmptyHeaders(detaisl);

      setIsModified(!_.isEqual(detaisl, modifiedWorkflowJson));
    }
  }, [tasks, hasEditorLoaded]);

  useEffect(() => {
    // reset taskErrors on workflow def init
    setTaskErrors([]);
  }, []);

  useEffect(() => {
    setDuration(
      workflowDays + workflowHours + workflowMinutes + workflowSeconds
    );

    // setDuration((prevState) => {
    //   let temp = 0;
    //   if (prevState !== undefined && prevState !== null && prevState != "") {
    //     console.log("prevState: ", prevState);
    //     temp =
    //       prevState +
    //       workflowDays +
    //       workflowHours +
    //       workflowMinutes +
    //       workflowSeconds;
    //   }
    //   return temp;
    // });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workflowDays, workflowHours, workflowMinutes, workflowSeconds]);

  /* create a generic node */
  function createTaskNode(
    displayName,
    name,
    refPrefix,
    type,
    joinTaskType = null,
    joinRef = null,
    randomRefText = null
  ) {
    displayName = getDisplayName(displayName);
    let randomText = "";
    let taskObj = null;

    if (
      // (type === TaskType.EndOfSwitch ||
      //   type === TaskType.Join ||
      //   type === TaskType.EndOfDoWhile) &&
      (name === TaskType.EndOfSwitch ||
        name === TaskType.EndOfForkJoin ||
        name === TaskType.EndOfDoWhile ||
        name === TaskType.EndTriggerApproval ||
        name === TaskType.EndSubWorkflow) &&
      randomRefText
    ) {
      randomText = splitTaskReferenceName(randomRefText);
    } else {
      randomText = generateRandomText();
    }

    // TaskType.Simple,
    // splitTaskReferenceName(forkSimpleNode.taskReferenceName),
    // forkJoinNode.taskReferenceName

    taskObj = {
      inputParameters: {},
      displayName: `${displayName.split("_").join(" ")}`,
      name: `${name}`,
      taskReferenceName: `${refPrefix}_${randomText}_ref`,
      type: `${type}`,
    };
    if (refPrefix === TaskType.EndOfSwitch && joinTaskType && joinRef) {
      taskObj["joinOn"] = [`${joinTaskType}_${joinRef}_ref`];
    }
    return taskObj;
  }

  /* create a switch component  */
  function createSwitchComponent(newTask) {
    /* Create switch node */
    let switchNode = createTaskNode(
      newTask.task,
      newTask.task,
      newTask.task,
      TaskType.Switch
    );
    if (switchNode == null) return;
    switchNode["inputParameters"] = {};
    switchNode["defaultCase"] = [];

    /* Create default node */
    let defaultNode = createTaskNode(
      TaskType.Default,
      TaskType.Default,
      TaskType.Default,
      TaskType.Label
    );
    if (defaultNode == null) return;
    switchNode.defaultCase.push(defaultNode);

    /* Add default case to default node */
    let defaultCase = createTaskNode(
      TaskType.Simple,
      TaskType.Simple,
      TaskType.Simple,
      TaskType.Simple
    );
    if (defaultCase == null) return;
    switchNode.defaultCase.push(defaultCase);

    /* Add end of switch */
    let endOfSwitchNode = createTaskNode(
      TaskType.EndOfSwitch,
      TaskType.EndOfSwitch,
      TaskType.EndOfSwitch,
      TaskType.Label,
      TaskType.Simple,
      splitTaskReferenceName(defaultCase.taskReferenceName),
      switchNode.taskReferenceName
    );
    endOfSwitchNode["inputParameters"] = {};

    return { switchNode, endOfSwitchNode };
  }

  /* create a fork component  */
  function createForkComponent(newTask) {
    /* Create fork node */
    let forkJoinNode = createTaskNode(
      TaskType.ForkJoin,
      TaskType.ForkJoin,
      TaskType.ForkJoin,
      TaskType.ForkJoin
    );
    if (forkJoinNode == null) return;
    forkJoinNode["inputParameters"] = {};
    forkJoinNode["defaultCase"] = [];
    forkJoinNode["forkTasks"] = [[]];

    /* Create fork branch node */
    let forkBranchNode = createTaskNode(
      TaskType.ForkBranch + " PATH 1",
      TaskType.ForkBranch,
      TaskType.ForkBranch,
      TaskType.Label
    );
    if (forkBranchNode == null) return;
    forkJoinNode.forkTasks[0].push(forkBranchNode);

    /* Add default case to fork branch node */
    let forkSimpleNode = createTaskNode(
      TaskType.Simple,
      TaskType.Simple,
      TaskType.Simple,
      TaskType.Simple
    );
    if (forkSimpleNode == null) return;
    forkJoinNode.forkTasks[0].push(forkSimpleNode);

    let joinNode = createTaskNode(
      TaskType.JoinTask,
      TaskType.JoinTask,
      TaskType.JoinTask,
      TaskType.JoinTask,
      TaskType.JoinTask
      // splitTaskReferenceName(forkSimpleNode.taskReferenceName),
      // forkJoinNode.taskReferenceName
    );

    /* Add join node label */
    let joinLabelNode = createTaskNode(
      TaskType.EndOfForkJoin,
      TaskType.EndOfForkJoin,
      TaskType.EndOfForkJoin,
      TaskType.Label,
      joinNode.taskReferenceName,
      splitTaskReferenceName(joinNode.taskReferenceName),
      forkJoinNode.taskReferenceName
    );
    joinNode["inputParameters"] = {};
    joinNode["forkTasks"] = forkJoinNode.forkTasks;
    joinNode["joinOn"] = [];
    return { forkJoinNode, joinNode, joinLabelNode };
  }

  /*Create a Trigger Approval componnet*/
  function createTriggerApprovalComponent(
    newTask,
    tasks,
    parentTaskReferenceName,
    switchTaskDetails
  ) {
    /* Create start trigger node */
    let startTriggerApprovalNode = createTaskNode(
      TaskType.StartTriggerApproval,
      TaskType.StartTriggerApproval,
      TaskType.StartTriggerApproval,
      TaskType.Label
    );
    if (!startTriggerApprovalNode) return;

    insertTask(
      tasks,
      parentTaskReferenceName,
      switchTaskDetails,
      startTriggerApprovalNode
    );
    parentTaskReferenceName = startTriggerApprovalNode.taskReferenceName;
    // create triggerApprovalNode
    let triggerApprovalNode = createTaskNode(
      TaskType.TriggerApproval,
      TaskType.TriggerApproval,
      TaskType.TriggerApproval,
      TaskType.TriggerApproval
    );
    if (!triggerApprovalNode) return;

    insertTask(
      tasks,
      parentTaskReferenceName,
      switchTaskDetails,
      triggerApprovalNode
    );
    parentTaskReferenceName = triggerApprovalNode.taskReferenceName;
    // create fetchApprovalNode
    let fetchApprovalNode = createTaskNode(
      TaskType.FetchApproval,
      TaskType.FetchApproval,
      TaskType.FetchApproval,
      TaskType.FetchApproval
    );
    fetchApprovalNode["inputParameters"] = {
      requestApprovalStepsId:
        triggerApprovalNode.taskReferenceName +
        ".output.response.body.data.requestApprovalStepsId",
    };

    insertTask(
      tasks,
      parentTaskReferenceName,
      switchTaskDetails,
      fetchApprovalNode
    );
    parentTaskReferenceName = fetchApprovalNode.taskReferenceName;

    // create switchNode
    const switchObj = { task: TaskType.Switch, type: "SYSTEM" };
    const { switchNode, endOfSwitchNode } = createSwitchComponent(
      switchObj,
      switchTaskDetails
    );
    insertTask(tasks, parentTaskReferenceName, switchTaskDetails, switchNode, [
      endOfSwitchNode,
    ]);

    parentTaskReferenceName = endOfSwitchNode.taskReferenceName;
    /* Create end trigger node */
    let endTriggerApprovalNode = createTaskNode(
      TaskType.EndTriggerApproval,
      TaskType.EndTriggerApproval,
      TaskType.EndTriggerApproval,
      TaskType.Label,
      null,
      null,
      startTriggerApprovalNode.taskReferenceName
    );
    if (!endTriggerApprovalNode) return;
    insertTask(
      tasks,
      parentTaskReferenceName,
      switchTaskDetails,
      endTriggerApprovalNode
    );

    return triggerApprovalNode.taskReferenceName;
  }

  function createSubWorkflowComponent(
    newTask,
    tasks,
    parentTaskReferenceName,
    switchTaskDetails
  ) {
    /* Create start trigger node */
    // let startSubWorkflowNode = createTaskNode(
    //   TaskType.StartSubWorkflow,
    //   TaskType.StartSubWorkflow,
    //   TaskType.StartSubWorkflow,
    //   TaskType.Label
    // );
    // if (!startSubWorkflowNode) return;

    // insertTask(
    //   tasks,
    //   parentTaskReferenceName,
    //   null,
    //   startSubWorkflowNode
    // );
    // parentTaskReferenceName = startSubWorkflowNode.taskReferenceName;

    let subWorkflowNode = createTaskNode(
      TaskType.SubWorkflow,
      TaskType.SubWorkflow,
      TaskType.SubWorkflow,
      TaskType.SubWorkflow
    );
    if (!subWorkflowNode) return;

    insertTask(
      tasks,
      parentTaskReferenceName,
      switchTaskDetails,
      subWorkflowNode
    );
    parentTaskReferenceName = subWorkflowNode.taskReferenceName;

    /* Create end trigger node */
    // let endSubWorkflowNode = createTaskNode(
    //   TaskType.EndSubWorkflow,
    //   TaskType.EndSubWorkflow,
    //   TaskType.EndSubWorkflow,
    //   TaskType.Label,
    //   null,
    //   null,
    //   startSubWorkflowNode.taskReferenceName
    // );
    // if (!endSubWorkflowNode) return;

    // insertTask(
    //   tasks,
    //   parentTaskReferenceName,
    //   null,
    //   endSubWorkflowNode
    // );

    return subWorkflowNode.taskReferenceName;
  }

  /* create a while component */
  function createDoWhileComponent(newTask) {
    /* Create while node */
    let doWhileNode = createTaskNode(
      TaskType.DoWhile,
      TaskType.DoWhile,
      TaskType.DoWhile,
      TaskType.DoWhile
    );
    if (doWhileNode == null) return;
    doWhileNode["inputParameters"] = {};
    doWhileNode["loopOver"] = [];
    /* Create while body node */
    let doWhileBodyNode = createTaskNode(
      TaskType.Simple,
      TaskType.Simple,
      TaskType.Simple,
      TaskType.Simple
    );
    if (doWhileBodyNode == null) return;
    doWhileNode.loopOver.push(doWhileBodyNode);
    /* Create end of while node */
    let endOfDoWhileNode = createTaskNode(
      TaskType.EndOfDoWhile,
      TaskType.EndOfDoWhile,
      TaskType.EndOfDoWhile,
      TaskType.Label,
      TaskType.Simple,
      splitTaskReferenceName(doWhileNode.taskReferenceName),
      doWhileNode.taskReferenceName
    );

    return { doWhileNode, endOfDoWhileNode };
  }
  const deleteSwitchCaseFromTask = (parentTask, selectedCase) => {
    let updatedTask = { ...parentTask };
    parentTask.decisionCases = _.omit(parentTask.decisionCases, selectedCase);
    setTasks(_.cloneDeep(tasks));
    closeTasksPopper();
    setTimeout(() => {
      handleWorkflowNodeClick({ ref: parentTask.taskReferenceName });
    }, 500);
  };

  /* add task in appropriate place */
  function insertTask(
    allTasks,
    parentTaskReferenceName,
    switchDetails,
    taskObj,
    followingTasks = []
  ) {
    if (parentTaskReferenceName === "__start") {
      if (allTasks) {
        allTasks.splice(0, 0, taskObj);
        if (followingTasks.length > 0) {
          allTasks.splice(1, 0, ...followingTasks);
        }
        setTasks(_.cloneDeep(allTasks));
      }
      closeTasksPopper();
      return;
    }
    let { task, tasks, taskIndex } = findNode(
      allTasks,
      parentTaskReferenceName
    );

    if (task && task.type === TaskType.Switch) {
      if (!task.decisionCases || _.isEmpty(task.decisionCases)) {
        task.decisionCases = {};
      }
      // create case note node
      let caseNode = createTaskNode(
        switchDetails.caseName,
        switchDetails.caseName,
        TaskType.SwitchCase,
        TaskType.Label
      );
      task.decisionCases[switchDetails.caseName] = [
        caseNode,
        taskObj,
        ...followingTasks,
      ];
      setTasks(_.cloneDeep(allTasks));
    } else if (task && task.type === TaskType.ForkJoin) {
      if (!task.forkTasks || _.isEmpty(task.forkTasks)) {
        task.forkTasks = [[]];
      }
      let pathNo = task.forkTasks.length + 1;
      let forkBranchNode = createTaskNode(
        TaskType.ForkBranch + " PATH " + `${pathNo}`,
        TaskType.ForkBranch,
        TaskType.ForkBranch,
        TaskType.Label
      );
      let newForkBranch = [];
      newForkBranch.push(forkBranchNode);
      newForkBranch.push(taskObj);
      newForkBranch.push(...followingTasks);
      task.forkTasks.push(newForkBranch);

      setTasks(_.cloneDeep(allTasks));
    } else if (task && task.type === TaskType.DoWhile) {
      if (!task.loopOver || _.isEmpty(task.loopOver)) {
        task.loopOver = [];
      }
      task.loopOver.splice(0, 0, taskObj);
      if (followingTasks.length > 0) {
        task.loopOver.splice(1, 0, ...followingTasks);
      }
      setTasks(_.cloneDeep(allTasks));
    } else {
      tasks.splice(taskIndex + 1, 0, taskObj);
      if (followingTasks.length > 0) {
        tasks.splice(taskIndex + 2, 0, ...followingTasks);
      }

      setTasks(_.cloneDeep(allTasks));
    }

    setIsModified(true);
    closeTasksPopper();
  }

  function findNode(tasks, parentTaskReferenceName) {
    let taskIndex = -1;

    for (const task of tasks) {
      taskIndex++;
      if (task.taskReferenceName != parentTaskReferenceName) {
        if (task.type === TaskType.Switch) {
          const { defaultCase, decisionCases } = task;
          for (let index = 0; index < 2; index++) {
            if (index == 0) {
              const obj = findNode(defaultCase, parentTaskReferenceName);
              if (obj != null) {
                return obj;
              }
            } else if (index == 1) {
              if (decisionCases && !_.isEmpty(decisionCases)) {
                for (const key in decisionCases) {
                  const decisionCase = decisionCases[key];
                  const obj = findNode(decisionCase, parentTaskReferenceName);
                  if (obj != null) {
                    return obj;
                  }
                }
              }
            }
          }
        } else if (task.type === TaskType.ForkJoin) {
          if (task.forkTasks && task.forkTasks.length > 0) {
            for (let index = 0; index < task.forkTasks.length; index++) {
              const forktask = task.forkTasks[index];
              const obj = findNode(forktask, parentTaskReferenceName);
              if (obj != null) {
                return obj;
              }
            }
          }
        } else if (task.type === TaskType.DoWhile) {
          const { loopOver } = task;
          if (task.loopOver && task.loopOver.length > 0) {
            for (let index = 0; index < task.loopOver.length; index++) {
              const looptask = task.loopOver;
              const obj = findNode(looptask, parentTaskReferenceName);
              if (obj != null) {
                return obj;
              }
            }
          }
        } else if (taskIndex + 1 == tasks.length) {
          return null;
        }
      } else if (task.taskReferenceName === parentTaskReferenceName) {
        return { task, tasks, taskIndex };
      }
    }
  }

  const handleDaysChange = (days) => {
    let seconds = 0;
    if (days) {
      if (!Number.isNaN(days)) {
        seconds = Math.floor(days * 3600 * 24);
      }
    }

    setWorkflowDays(seconds);
    setIsModified(true);
  };

  const handleHoursChange = (hours) => {
    let seconds = 0;
    if (hours) {
      if (!Number.isNaN(hours)) {
        seconds = Math.floor(hours * 3600);
      }
    }

    setWorkflowHours(seconds);
    setIsModified(true);
  };
  const handleMinutesChange = (minutes) => {
    let seconds = 0;
    if (minutes) {
      if (!Number.isNaN(minutes)) {
        seconds = Math.floor(minutes * 60);
      }
    }

    setWorkflowMinutes(seconds);
    setIsModified(true);
  };
  const handleSecondsChange = (secs) => {
    let seconds = 0;
    if (secs) {
      if (!Number.isNaN(secs)) {
        seconds = Math.floor(secs);
      }
    }

    setWorkflowSeconds(seconds);
    setIsModified(true);
  };

  const addTask = (newTask, switchTaskDetails = null) => {
    let parentTaskReferenceName = clickedAddBtnNode;
    let taskObj = null;

    if (newTask) {
      let refObj = { ref: "" };
      if (newTask.task === TaskType.Switch) {
        const { switchNode, endOfSwitchNode } = createSwitchComponent(
          newTask,
          switchTaskDetails
        );
        insertTask(
          tasks,
          parentTaskReferenceName,
          switchTaskDetails,
          switchNode,
          [endOfSwitchNode]
        );
        refObj.ref = switchNode.taskReferenceName;
      } else if (newTask.task === TaskType.ForkJoin) {
        const { forkJoinNode, joinNode, joinLabelNode } = createForkComponent(
          newTask
        );
        if (forkJoinNode && joinNode && joinLabelNode) {
          insertTask(
            tasks,
            parentTaskReferenceName,
            switchTaskDetails,
            forkJoinNode,
            [joinNode, joinLabelNode]
          );
          refObj.ref = forkJoinNode.taskReferenceName;
        }
      } else if (newTask.task === TaskType.DoWhile) {
        const { doWhileNode, endOfDoWhileNode } = createDoWhileComponent(
          newTask
        );

        if (doWhileNode && endOfDoWhileNode) {
          insertTask(
            tasks,
            parentTaskReferenceName,
            switchTaskDetails,
            doWhileNode,
            [endOfDoWhileNode]
          );

          refObj.ref = doWhileNode.taskReferenceName;
        }
      } else if (newTask.task === TaskType.TriggerApproval) {
        refObj.ref = createTriggerApprovalComponent(
          newTask,
          tasks,
          parentTaskReferenceName,
          switchTaskDetails
        );
      } else if (newTask.task === TaskType.SubWorkflow) {
        refObj.ref = createSubWorkflowComponent(
          newTask,
          tasks,
          parentTaskReferenceName,
          switchTaskDetails
        );
      } else {
        taskObj = createTaskNode(
          newTask.task,
          newTask.task,
          newTask.task,
          newTask.task
        );
        insertTask(tasks, parentTaskReferenceName, switchTaskDetails, taskObj);
        refObj.ref = taskObj.taskReferenceName;
      }

      setTimeout(() => {
        if (refObj.ref) {
          handleWorkflowNodeClick(refObj);
        }
      }, 500);
    }
  };

  const updateTaskFromTaskDefinationTab = (newVal, taskData) => {
    if (newVal) {
      let randomText = generateRandomText();

      let taskObj = {
        displayName: `${newVal.task.split("_").join(" ")}`,
        name: `${newVal.task}`,
        taskReferenceName: `${newVal.task}_${randomText}_ref`,
        type: newVal.task,
      };

      if (newVal.task === "SWITCH") {
        let randomText = generateRandomText();
        taskObj["defaultCase"] = [
          {
            displayName: "SIMPLE",
            name: "SIMPLE",
            taskReferenceName: `DEFAULT-CASE_${randomText}_ref`,
            type: "SIMPLE",
          },
        ];
      }
      let dataToBeModified = [];
      if (tasks) dataToBeModified = [...tasks];

      for (let i = 0; i < dataToBeModified.length; i++) {
        if (
          dataToBeModified[i].taskReferenceName === taskData.taskReferenceName
        ) {
          dataToBeModified[i] = taskObj;
          break;
        }
      }
      setTasks(dataToBeModified);
    }
  };

  const closeTasksPopper = () => {
    setShowTasksPopper(false);
    setClickedAddBtnNode(null);
    setClickedDeletePathBtnNode(null);
  };

  const updateTaskListWithTask = (taskObj, prevTaskObj) => {
    const list = updateTaskList(tasks, taskObj, prevTaskObj);
    setTasks(list);
  };

  const TaskPopper = useMemo(() => {
    if (showTasksPopper && clickedDeletePathBtnNode) {
      const taskObj = getTaskObj(tasks, clickedDeletePathBtnNode);
      if (taskObj) {
        const { type } = taskObj;

        if (type === "SWITCH") {
          return (
            <SwitchCasesPopperUI
              open={showTasksPopper}
              anchorEl={clickedDeletePathBtnNode}
              setShowTasksPopper={setShowTasksPopper}
              closeTasksPopper={closeTasksPopper}
              task={taskObj}
              updateTaskListWithTask={updateTaskListWithTask}
              deleteSwitchCaseFromTask={deleteSwitchCaseFromTask}
            />
          );
        } else if (type === TaskType.ForkJoin) {
          return (
            <ForkPathsPopperUI
              open={showTasksPopper}
              anchorEl={clickedDeletePathBtnNode}
              setShowTasksPopper={setShowTasksPopper}
              closeTasksPopper={closeTasksPopper}
              task={taskObj}
              updateTaskListWithTask={updateTaskListWithTask}
              // deleteForkPathFromTask={deleteForkPathFromTask}
              deleteForkPathFromTask={handleDeleteForkPath}
              selectedCase={selectedForkCase}
              setSelectedCase={setSelectedForkCase}
            />
          );
        }
      } else {
        return null;
      }
    } else if (showTasksPopper && clickedAddBtnNode) {
      const taskObj = getTaskObj(tasks, clickedAddBtnNode);
      if (taskObj) {
        const { type } = taskObj;

        if (type === TaskType.Switch) {
          return (
            <SwitchTaskPopperUI
              open={showTasksPopper}
              anchorEl={clickedAddBtnNode}
              setShowTasksPopper={setShowTasksPopper}
              task={taskObj}
              updateTaskListWithTask={updateTaskListWithTask}
              addTask={addTask}
            />
          );
        } else {
          return (
            <TaskPopperUi
              open={showTasksPopper}
              anchorEl={clickedAddBtnNode}
              setShowTasksPopper={setShowTasksPopper}
              setClickedAddBtnNode={setClickedAddBtnNode}
              setTaskSelectedFromList={handleTaskSelectedFromList}
              addTask={addTask}
            />
          );
        }
      } else if (clickedAddBtnNode == "__start") {
        return (
          <TaskPopperUi
            open={showTasksPopper}
            anchorEl={clickedAddBtnNode}
            setShowTasksPopper={setShowTasksPopper}
            setClickedAddBtnNode={setClickedAddBtnNode}
            setTaskSelectedFromList={handleTaskSelectedFromList}
            addTask={addTask}
          />
        );
      }

      {
        return null;
      }
    } else {
    }
    setTasks(_.cloneDeep(tasks));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clickedAddBtnNode, showTasksPopper]);

  const ConformationDialog = useMemo(() => {
    const { openDialog, header, message, ref } = clickedDeleteBtnNode;
    if (openDialog) {
      return (
        <ConfirmChoiceDialog
          header={header}
          message={message}
          handleConfirmationValue={(confirm) =>
            handleConfirmDelete({ ref, confirm })
          }
          open={openDialog}
        />
      );
    } else {
      return null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clickedDeleteBtnNode]);

  const setIsNodeOnClickEnabled = (val) => {
    setLoading(val);
  };
  const disableSaveButton = () => {
    return (
      !_.isEmpty(jsonErrors) ||
      !isModified ||
      !_.isEmpty(taskErrors) ||
      jsonParseError
    );
  };
  const disableResetButton = () => {
    return !isModified;
  };

  const toggleSplitPanel = (minimize = true) => {
    if (minimize) {
      setSplitMinSizes([0, 0]);
      setSplitMaxSizes([Infinity, 0]);
      setSplitSizes([100, 0]);
    } else {
      setSplitMinSizes([0, 500]);
      setSplitMaxSizes([Infinity, 800]);
      setSplitSizes([50, 50]);
    }
    dispatch({ type: actions.TOGGLE_GRAPH_PANEL });
  };

  return (
    <>
      <Helmet>
        <title>
          Conductor UI - Workflow Definition - {workflowName || "New Workflow"}
        </title>
      </Helmet>

      <ResetConfirmationDialog
        version={resetDialog}
        onConfirm={changeVersionOrReset}
        onClose={() => setResetDialog(false)}
      />

      <SaveWorkflowDialog
        document={saveDialog}
        onCancel={handleSaveCancel}
        onSuccess={handleSaveSuccess}
        versions={wfVersions}
      />

      {isFetching && <LinearProgress />}
      {/* {isLoading && <DefaultLoader  
       displayModal={true}
       message={'test'}
      
      
      />} */}
      <div className={classes.wrapper}>
        <Split
          className="flex-row"
          sizes={splitSizes}
          minSize={splitMinSizes}
          maxSize={splitMaxSizes}
          gutterSize={10}
          gutterAlign="center"
          direction="horizontal"
          cursor="col-resize">
          <div className={classes.workflowGraph}>
            {dag && (
              <WorkflowGraph
                dag={dag}
                onClick={isTaskDataLoading ? () => {} : handleWorkflowNodeClick}
                onAddBtnClick={handleWorkflowAddBtnClick}
                onSubtractBtnClick={handleSwitchCaseDeleteBtnClick}
                onDeleteBtnClick={handleWorkflowDeleteBtnClick}
                navigate={navigate}
                // setSelectedTask={setSelectedTask}
                selectedTask={selectedTask}
                isLoading={isLoading}
                setIsLoading={updateLoading}
                hasEditorLoaded={hasEditorLoaded}
                componentLoadedFrom={"Definition"}
                isModified={!_.isNull(isModified) && isModified}
                onExpand={handleExpandChange}
                onCollapse={handleCollapseChange}
                dpr={dpr}
              />
            )}

            <IconButton
              onClick={() => {
                toggleSplitPanel(false);
              }}
              className={`${classes.togglebtn}`}>
              {workflowDefState.toggleGraphPanel && (
                <KeyboardArrowRightRounded />
              )}
              {!workflowDefState.toggleGraphPanel && (
                <KeyboardArrowLeftRounded />
              )}
            </IconButton>
          </div>
          <div className={classes.workflowCodePanel}>
            <Toolbar>
              <Text className={classes.workflowName}>
                {workflowDisplayName || "NEW"}
              </Text>

              <Select
                className={classes.verSelect}
                disabled={!workflowDef}
                // value={_.isUndefined(workflowVersion) ? "" : workflowVersion}
                value={
                  _.isUndefined(selectedVersion) ||
                  validSelectedVersion === false
                    ? ""
                    : workflowVersion
                }
                displayEmpty
                renderValue={(v) =>
                  v === "" ? "Latest Version" : `Version ${v}`
                }
                onChange={(evt) => {
                  handleResetVersion(evt.target.value);
                }}>
                <MenuItem value="">
                  Latest Version - Version{" "}
                  {versions && versions.length > 0 ? versions.length : 0}
                </MenuItem>
                {versions && versions.length > 0
                  ? versions
                      .sort((a, b) => b.version - a.version)
                      .map((row) => {
                        const version = row.version ? row.version : row;
                        const versionTimeValue = versionTime(version);

                        return (
                          <MenuItem value={row} key={version}>
                            Version {version}{" "}
                            {versionTimeValue ? `(${versionTimeValue})` : ""}
                          </MenuItem>
                        );
                      })
                  : null}
              </Select>

              {!_.isNull(isModified) &&
                (isModified ? (
                  <Pill color="yellow" label="Modified" />
                ) : (
                  <Pill label="Unmodified" />
                ))}
              {(!_.isEmpty(jsonErrors) ||
                !_.isEmpty(taskErrors) ||
                jsonParseError) && (
                <Tooltip
                  disableFocusListener
                  title="There are validation or syntax errors. Validation errors at the root level may be seen by hovering over the opening brace.">
                  <div>
                    <Pill color="red" label="Validation" />
                  </div>
                </Tooltip>
              )}
              {permissions?.workflows?.actions?.create_workflow === "True" ? (
                <div className={classes.rightButtons}>
                  <Button
                    disabled={disableSaveButton()}
                    onClick={handleOpenSave}
                    variant="contained"
                    color="primary">
                    Save
                  </Button>

                  <Button
                    onClick={() => handleResetVersion(workflowVersion)}
                    variant="outlined"
                    color="primary"
                    disabled={disableResetButton()}>
                    Reset
                  </Button>

                  <IconButton
                    onClick={() => {
                      toggleSplitPanel();
                    }}>
                    {workflowDefState.toggleGraphPanel && (
                      <KeyboardArrowRightRounded />
                    )}
                    {!workflowDefState.toggleGraphPanel && (
                      <KeyboardArrowLeftRounded />
                    )}
                  </IconButton>
                </div>
              ) : (
                <div className={classes.rightButtons}>
                  <IconButton
                    onClick={() => {
                      toggleSplitPanel();
                    }}>
                    {workflowDefState.toggleGraphPanel && (
                      <KeyboardArrowRightRounded />
                    )}
                    {!workflowDefState.toggleGraphPanel && (
                      <KeyboardArrowLeftRounded />
                    )}
                  </IconButton>
                </div>
              )}
            </Toolbar>
            <div className={classes.workflowDefTabs}>
              <Tabs
                value={value}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                aria-label="basic tabs">
                <Tab label="Workflow" />
                <Tab label="Task" />
                <Tab label="Code" />
              </Tabs>
            </div>
            <div
              className={classes.workflowDefTabPannels}
              hidden={value !== 0}
              value={value}
              index={0}>
              <WorkflowDefinationForm
                innerRef={workflowFormRef}
                dataToBeAddedToJSON={dataToBeAddedToJSON}
                setDataToBeAddedToJson={setDataToBeAddedToJson}
                // workflowDef={workflowDef}
                workflowDef={
                  newWorkflow ? JSON.parse(newWorkflow) : workflowDef
                }
                durationVal={duration}
                workflowDays={workflowDays}
                workflowHours={workflowHours}
                workflowMinutes={workflowMinutes}
                workflowSeconds={workflowSeconds}
                setWorkflowDays={setWorkflowDays}
                setWorkflowHours={setWorkflowHours}
                setWorkflowMinutes={setWorkflowMinutes}
                setWorkflowSeconds={setWorkflowSeconds}
                setDuration={setDuration}
                handleDaysChange={handleDaysChange}
                handleHoursChange={handleHoursChange}
                handleMinutesChange={handleMinutesChange}
                handleSecondsChange={handleSecondsChange}
              />
            </div>
            <div
              className={`${classes.workflowDefTabPannels} ${classes.taskPanel} `}
              hidden={value !== 1}
              value={value}
              index={1}>
              <TaskDefinationTab
                tasks={tasks}
                setTasks={setTasks}
                inputParameters={inputParameters}
                id="workflowDef-taskTab"
                clickedWorkflowNodeTaskRef={clickedWorkflowNodeTaskRef}
                setClickedWorkflowNodeTaskRef={setClickedWorkflowNodeTaskRef}
                changeTask={updateTaskFromTaskDefinationTab}
                setIsNodeOnClickEnabled={setIsNodeOnClickEnabled}
                isEditorMounted={isEditorMounted}
                setIsTaskDataLoading={setIsTaskDataLoading}
                setTaskData={setTaskData}
                taskData={taskData}
                setClickedTask={setClickedTask}
                clickedTask={clickedTask}
                selectedVersion={selectedVersion}
                workflowDef={
                  newWorkflow ? JSON.parse(newWorkflow) : workflowDef
                }
                nodeClicked={nodeClicked}
                onModifiedJQ={setIsModified}
                onJsonErrors={handleJsonErrors}
                setEditorDelay={setEditorDelay}
              />
            </div>
            {isCodeModified &&
            permissions?.workflows?.actions?.create_workflow === "True" ? (
              <div>
                <span className={classes.saveCode}>
                  {jsonParseError || !_.isEmpty(jsonErrors) ? (
                    <Text style={{ color: "red" }}>
                      You have some errors. Please fix them before saving code.
                    </Text>
                  ) : (
                    <Text>
                      Code modified. Please save to view your changes.
                    </Text>
                  )}
                  <div className={classes.rightCodeBtn}>
                    <Button
                      disabled={!_.isEmpty(jsonErrors) || jsonParseError}
                      onClick={handleOpenSave}>
                      Save Code
                    </Button>
                  </div>
                </span>
              </div>
            ) : null}
            <div
              // className={classes.workflowDefTabPannels}
              hidden={value !== 2}
              value={value}
              index={2}
              style={{ height: "100vh" }}>
              <Editor
                height="100%"
                width="100%"
                theme="vs-light"
                language="json"
                value={workflowJsonWithoutSubWf}
                autoIndent={true}
                beforeMount={handleEditorWillMount}
                onMount={handleEditorDidMount}
                onValidate={handleValidate}
                onChange={(newValue, event) =>
                  handleEditorChange(newValue, event)
                }
                options={{
                  smoothScrolling: true,
                  selectOnLineNumbers: true,
                  minimap: {
                    enabled: false,
                  },
                }}
                path={JSON_FILE_NAME}
              />
            </div>
          </div>
        </Split>
      </div>
      {TaskPopper}
      {ConformationDialog}
    </>
  );
}

function versionTime(versionObj) {
  return (
    versionObj &&
    timestampRenderer(versionObj.updateTime || versionObj.createTime)
  );
}
